module.exports = __webpack_public_path__ + "static/media/coliseu_porto_ageas_circo_2017_12.96eb3a02.jpg";